import { INavConfigDesktop } from '@pendwa/common-browser/components/Navs/Nav/types.js';
import { IContextPageDataViewer } from '@pendwa/common-browser/context/PageData/index.js';
import { rootRoutes } from '@pendwa/common/core/rootRoutes/index.js';
import { middleSection } from './middleSection.js';
import { rightSection } from './rightSection.js';

export const linksDesktop = (params: { viewer?: IContextPageDataViewer }): INavConfigDesktop => {
  return {
    main: {
      link: {
        label: browserRootConfig.project.name,
        navigate: {
          description: 'Home page.',
          href: domain_env_pendwa_app
            ? rootRoutes.shows.main.get()
            : domain_env_africacrosswords_com
              ? rootRoutes.crosswords.main.get()
              : domain_env_swiftcomment_com
                ? rootRoutes.sc.main.get()
                : domain_env_pendwa_org
                  ? rootRoutes.console.main.get()
                  : rootRoutes.home.main.get(),
        },
      },
    },
    middle_section: middleSection(params),
    right_section: rightSection(params),
  };
};
